/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import { useApi } from 'app/api/APIProvider';
import cls from './TransactionOpenCard.module.scss';

interface TransactionProps {
    transaction: any
}

export const TransactionOpenCard = ({ transaction }: TransactionProps) => {
    const api = useApi();
    // const { name, deposit, sumPerYear, savedProcents } = transaction;

    return (
        <div className={cls.card}>
            <div className={cls.content}>
                <div className={cls.contentElem}>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20_700}>Ежемесячный взнос</Text>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20}>2 000 ₽</Text>
                </div>
                <div className={cls.contentElem}>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20_700}>Дополнительный доход</Text>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20}>3 года</Text>
                </div>
                <div className={cls.contentElem}>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20_700}>Срок</Text>
                    <Text className={cls.title} color="#ffffff" size={TextSize.text_20}>75 530,04 ₽</Text>
                </div>
            </div>
        </div>
    );
};

